/* toast.svelte.js generated by Svelte v5.56.9 */
import * as $ from 'svelte/internal/client';

export const toasts = $.tag_proxy($.proxy({ items: [] }), 'toasts');

let nextId = 1;

export function toast(message, { tone = "info", timeout = 4000 } = {}) {
	const id = nextId++;

	toasts.items = [...toasts.items, { id, message, tone }].slice(-3);

	if (timeout > 0) setTimeout(() => dismissToast(id), timeout);

	return id;
}

export function dismissToast(id) {
	toasts.items = toasts.items.filter((item) => $.strict_equals(item.id, id, false));
}

export const toastError = (message) => toast(message, { tone: "error", timeout: 6000 });
export const toastSuccess = (message) => toast(message, { tone: "success" });